export default defineNuxtPlugin(async (nuxtApp) => {
    const authStore = useAuthStore();
    const personStore = usePersonStore();
    const route = useRoute();

    // Skip hooks on auth/callback page
    if (route.path === '/auth/callback') {
        return;
    }

    if ( authStore.loggedIn ) {
        await authStore.getMe();
        await personStore.getPerson();
    }
});
